import React, { Component } from 'react';

class CloseIcon extends Component {
  render() {
    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <svg
          width={this.props.width}
          height={this.props.height}
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="9.5" cy="9" r="9" fill={this.props.iconColor} />
          <path
            d="M9.5 9.6229L6.50135 12.6215C6.41951 12.7034 6.31664 12.7453 6.19274 12.7471C6.06885 12.749 5.96409 12.7072 5.87846 12.6215C5.79282 12.5359 5.75 12.4321 5.75 12.3101C5.75 12.1881 5.79282 12.0843 5.87846 11.9987L8.8771 9L5.87846 6.00135C5.79661 5.91951 5.75474 5.81664 5.75285 5.69274C5.75095 5.56885 5.79282 5.46409 5.87846 5.37846C5.96409 5.29282 6.0679 5.25 6.1899 5.25C6.3119 5.25 6.41572 5.29282 6.50135 5.37846L9.5 8.3771L12.4987 5.37846C12.5805 5.29661 12.6834 5.25474 12.8073 5.25285C12.9312 5.25095 13.0359 5.29282 13.1215 5.37846C13.2072 5.46409 13.25 5.5679 13.25 5.6899C13.25 5.8119 13.2072 5.91572 13.1215 6.00135L10.1229 9L13.1215 11.9987C13.2034 12.0805 13.2453 12.1834 13.2471 12.3073C13.249 12.4312 13.2072 12.5359 13.1215 12.6215C13.0359 12.7072 12.9321 12.75 12.8101 12.75C12.6881 12.75 12.5843 12.7072 12.4987 12.6215L9.5 9.6229Z"
            fill="white"
          />
        </svg>
      </div>
    );
  }
}

export { CloseIcon }